import { render, staticRenderFns } from "./SwiftPay.vue?vue&type=template&id=8a37b5f4"
import script from "./SwiftPay.vue?vue&type=script&lang=js"
export * from "./SwiftPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports